module.exports = __webpack_public_path__ + "static/media/accessibility.037c1a05.svg";